import request from '@/utils/request.js'


/**
 * 省市区区域接口
 * @param params
 * @returns {AxiosPromise}
 */
export function listDistricts(params) {
    return request({
        url: '/operateService/api/dictionary/listDistricts',
        method: 'post',
        data: params
    })
}


export function getOssKey(params) {
    return request({
        closeLoading: true,
        url: '/operateService/api/oss/object/getPolicy',
        method: 'post',
        data: params
    })
}
